export default __webpack_public_path__ + "static/media/reset.6f588cfa.svg";